<template>
  <div class="page border-box" :class="cardShow==1|| loginShow==1?'overflow':''" v-wechat-title="$route.meta.title">
    <div class="page_box" :class="mapStyle==1?'map_style':''" :style="mapStyle==1?'background: url(https://filewc.geeker.com.cn/%E9%87%91%E7%89%8C%E8%A7%A3%E8%AF%B4%E5%B0%8F%E7%A8%8B%E5%BA%8F/study_map_bg-new.jpg) repeat-y center; background-size: 100% auto;!important;':''">
      <!--轮播图-->
      <div class="banner border-box" v-show="mapStyle==0">
        <Swiper :banners="banners" :type="''"></Swiper>
      </div>
      <img class="icon_flag" v-show="flagShow==1" src="../../assets/flag.png" alt="" :style="{'left':flagLeft,'top':flagTop}">

      <!--景点路线-->
      <div class="spot_ul border-box">
        <div class="spot_li_box spot_li bgF border-box">
        <span class="complete_score" v-show="isComplete==1">
          <img src="../../assets/study_border.png" alt="">
          完成研学<br>{{score}}分
        </span>
          <div class="spot_name hide">{{shopInfo.name}}</div>
          <div class="spot_sub" :class="slideState==1?'curr':'hide2'">{{shopInfo.info}}</div>
          <div class="slide_info" v-show="shopInfo.info.length>60" @click="slideInfo()">{{slideInfoTxt}}</div>
          <div class="spot_bot" v-show="shopInfo.is_sign">
            <img class="fl spot_icon" src="../../assets/icon_18_study.png" alt="">
            {{shopInfo.signs|initNumber}}人打卡
            <span @click="signListFun(pageAlert)">查看排行>></span>
            <!--<span class="fr spot_btn"  @click="cardShow=1">-->
          <span class="fr spot_btn"  @click="cardShow=1" v-show="isSign==0">
            <img src="../../assets/icon_19_study.png" alt="">
            拍照打卡
          </span>
          <span class="fr spot_btn is_spot_btn" v-show="isSign==1">
            <img src="../../assets/icon_19_study.png" alt="">
            已打卡
          </span>
          </div>
        </div>

        <!--<div ref="heightBox">-->

          <div class="spot_li_box clearfix" :id="'spotLiTop'+item.id" v-for="(item,index) in spotList" :class="index==currMapLi?'curr':''" @click="removeCurr()">
            <img class="map_close" src="../../assets/icon_close.png" alt="" @click.stop="(currMapLi=-1,flagShow=0)">
            <div class="map_con" v-show="mapStyle==1"  @click="clickMapLi(index,$event)">
              <img class="map_logo_bg" src="../../assets/mask_map_bg.png" alt="">
              <img class="img map_logo" v-lazy="item.logo" alt="" style="-webkit-mask-image: url(https://filewc.geeker.com.cn/%E9%87%91%E7%89%8C%E8%A7%A3%E8%AF%B4%E5%B0%8F%E7%A8%8B%E5%BA%8F/mask_map.png);-webkit-mask-repeat: no-repeat;-webkit-mask-size: 100% 100%;">

              <div class="map_bot border-box">
                <img class="icon_complete" src="../../assets/icon_cw.png" alt="" v-show="item.state==1&&item.answer==0">
                <img class="icon_complete" src="../../assets/icon_zq.png" alt="" v-show="item.state==1&&item.answer==1">

                <div class="map_bot_t hide">{{item.name}}></div>
                <div class="map_bot_b clearfix">
                  <img class="fl" src="../../assets/icon_28_study.png" alt="">
                  {{item.total}}人答题
                </div>
              </div>
            </div>

            <div class="spot_li spot_question bgF box border-box" @click.stop="">
              <!--<img class="icon_flag"  src="../../assets/icon_flag.png" alt="" >-->

              <img class="img flex" v-lazy="item.logo"  alt="" @click.stop="seeImg(0,item.logo)">
              <div class="flex">
                <div class="spot_q_top box">
                  <div class="flex name hide">{{item.name}}</div>
                  <div class="flex num">{{item.total}}人答题</div>
                </div>
                <div class="spot_q_bot">
                  <span class="spot_q_btn1" v-if="item.state==1&&item.answer==1" @click.stop="questionFun(item.id,item.state,index),guideSpotId1=item.spotid">我的答题 <img src="../../assets/icon_dui_study.png" alt=""></span>
                  <span class="spot_q_btn1" v-if="item.state==1&&item.answer==0" @click.stop="questionFun(item.id,item.state,index),guideSpotId1=item.spotid">我的答题 <img src="../../assets/icon_cuo_study.png" alt=""></span>
                  <span class="spot_q_btn1" v-if="item.state==0"  @click.stop="questionFun(item.id,item.state,index),guideSpotId1=item.spotid">研学答题打卡</span>
                  <span class="fr spot_q_btn2" @click.stop="openGuidelist(item.spotid)">听解说 找答案</span>
                </div>
              </div>
            </div>
          </div>

        <!--</div>-->


      </div>

      <p class="load-tip" ref="loadtip">{{loadText}}</p>

    </div>


    <!--底部按钮-->
    <div class="fix_btn" @click="openGuidelist('')" v-show="mapStyle==0">听解说 找答案</div>

    <!--专辑列表弹窗-->
    <div class="toast" v-if="guidelistShow==1">
      <div class="spot">
        <img class="spot-close" src="../../assets/icon_05.png" alt="" @click="guidelistShow=0">
        <div class="guide-info flex">
          <h3 class="hide">听解说 找答案</h3>
        </div>
        <div class="spot-guide border-box">
          <div class="spot-scoll border-box">
            <div class="scoll-list clearfix">
              <div class="list-li" v-for="(item,index) in guidelist" :key="index" @click="openGuide(item.id)">
                <div class="list-li-img">
                  <img class="img" v-lazy="item.headimg" alt="">
                  <span class="gif" v-if="playing==1&&bagid==item.id"><img src="../../assets/icon_listen01.gif" alt=""></span>
                  <p><img src="../../assets/icon_20.png" alt="">{{item.listens|initNumber}}</p>
                </div>
                <h3 class="hide">{{item.guide}}</h3>
                <p class="hide">{{item.guidetag || item.NAME}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--导游+语音弹窗-->
    <div class="toast" v-show="videoShow==1">
      <div class="voice-box">
        <img class="toast-close" src="../../assets/icon_05.png" alt="" @click="videoShow=0">
        <!--未购买-->
        <div class="guide" v-if="buy==false&&guideinfo.id">
          <div class="guide-box border-box box">
            <div class="guide-img"><img class="img" v-lazy="guideinfo.guideheadimg2" alt=""></div>
            <div class="guide-info flex">
              <h3 class="hide">{{guideinfo.bagname}}</h3>
              <p class="hide">{{guideinfo.guidename2}}{{guideinfo.guidetag?'| '+guideinfo.guidetag:''}}</p>
              <div class="clearfix guide-lable">
                <p><img src="../../assets/icon-label-listen.png" alt=""> {{guideinfo.listens|initNumber}}收听</p>
                <p><img src="../../assets/icon-label-sees.png" alt=""> 包含{{guideinfo.spots}}个景点解说</p>
              </div>
              <button class="guidebtn" @click="buyVideo">{{guideinfo.price}}元  购买</button>
            </div>
          </div>
        </div>
        <!--已购买-->
        <div class="guide guide1" v-if="buy==true&&guideinfo.id">
          <div class="bg"></div>
          <div class="guide-box border-box box">
            <div class="guide-img"><img class="img" v-lazy="guideinfo.guideheadimg2" alt=""></div>
            <div class="guide-voice flex">
              <p class="guide-tit">当前播放：{{voicelist[playIndex1].spotname}}</p>
              <div class="guide-slider border-box clearfix">
                <div class="guide-slider-left">
                  <p id="playSlider">
                    <span :style="{width:currSlider}" ></span>
                    <i class="speedDot" :style="{left:currSlider}"></i>
                  </p>
                </div>
                <span class="guide-slider-right">{{voicelist[playIndex1].totaltime|initTime}}</span>
              </div>
              <div class="guide-btn1">
                <img class="fl" src="../../assets/icon_11.png" alt="" @click="prevPlay()">
                <img class="fl play" :src="playing==0?require('../../assets/icon_12.png'):require('../../assets/icon_12_curr.png')" alt="" @click="playVideoClick(playIndex1)">
                <img class="fl" src="../../assets/icon_13.png" alt="" @click="nextPlay()">
              </div>
            </div>
          </div>
        </div>
        <!--语音列表-->
        <div class="guide-scoll" id="scollBox0">
          <div class="scoll-tab">
            <div class="voice-list">
              <p class="voice-list-p clearfix" :id="'voice-list-p'+item.spotid" v-for="(item,index) in voicelist" :key="index" :class="playIndex==index?'curr':''" @click="playVideoClick(index)">
                <img class="fl" src="../../assets/icon_16.png" alt="" v-if="playIndex==index">
                <span v-else>{{index+1}}.</span>
                {{item.spotname}}
                <font v-if="index<=1&&buy!=true">(免费收听）</font>
                <span class="fr" v-if="playIndex==index">{{playTime|initTime}}</span>
                <img class="fr" :src="(index<=1||buy==true)?require('../../assets/icon_15.png'):require('../../assets/icon_14.png')" alt="" v-else>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--答题弹窗-->
    <div class="alert_question" :class="questionShow==0?'none':''">
      <span class="mask" @click="closeAnswer"></span>
      <div class="question_box border-box">
        <span class="question_logo">研学答题卡</span>
        <img class="question_close" src="../../assets/icon_05.png" alt="" @click="closeAnswer">
        <div class="question_tit">{{questionList.title}}</div>
        <div class="answer">
          <div v-if="question1.A">
            <div v-if="questionList.answer=='A'&&questionList.state==0" class="answer_li border-box error" data-type="A">
              <span class="answer_type">A</span>
              <div class="answer_info">{{question1.A}}</div>
            </div>
            <div v-if="(questionList.answer=='A'&&questionList.state==1)||(questionList.answer!='A'&&questionList.realAnswer=='A'&&questionList.state==0)" class="answer_li border-box right" data-type="A">
              <span class="answer_type">A</span>
              <div class="answer_info">{{question1.A}}</div>
            </div>
            <div class="answer_li border-box" data-type="A"  :class="chooseType=='A'?'curr':''" @click="chooseAnswer($event)" v-if="(questionList.answer!='A'&&questionList.realAnswer!='A')">
              <span class="answer_type">A</span>
              <div class="answer_info">{{question1.A}}</div>
            </div>
          </div>

          <div v-if="question1.B">
            <div v-if="questionList.answer=='B'&&questionList.state==0" class="answer_li border-box error" data-type="B">
              <span class="answer_type">B</span>
              <div class="answer_info">{{question1.B}}</div>
            </div>
            <div v-if="(questionList.answer=='B'&&questionList.state==1)||(questionList.answer!='B'&&questionList.realAnswer=='B'&&questionList.state==0)" class="answer_li border-box right" data-type="B">
              <span class="answer_type">B</span>
              <div class="answer_info">{{question1.B}}</div>
            </div>
            <div class="answer_li border-box" data-type="B"  :class="chooseType=='B'?'curr':''" @click="chooseAnswer($event)"  v-if="(questionList.answer!='B'&&questionList.realAnswer!='B')">
              <span class="answer_type">B</span>
              <div class="answer_info">{{question1.B}}</div>
            </div>
          </div>

          <div v-if="question1.C">
            <div v-if="questionList.answer=='C'&&questionList.state==0" class="answer_li border-box error" data-type="C">
              <span class="answer_type">C</span>
              <div class="answer_info">{{question1.C}}</div>
            </div>
            <div v-if="(questionList.answer=='C'&&questionList.state==1)||(questionList.answer!='C'&&questionList.realAnswer=='C'&&questionList.state==0)" class="answer_li border-box right" data-type="C">
              <span class="answer_type">C</span>
              <div class="answer_info">{{question1.C}}</div>
            </div>
            <div class="answer_li border-box" data-type="C"  :class="chooseType=='C'?'curr':''" @click="chooseAnswer($event)"  v-if="(questionList.answer!='C'&&questionList.realAnswer!='C')">
              <span class="answer_type">C</span>
              <div class="answer_info">{{question1.C}}</div>
            </div>
          </div>

          <div v-if="question1.D">
            <div v-if="questionList.answer=='D'&&questionList.state==0" class="answer_li border-box error" data-type="D">
              <span class="answer_type">D</span>
              <div class="answer_info">{{question1.D}}</div>
            </div>
            <div v-if="(questionList.answer=='D'&&questionList.state==1)||(questionList.answer!='D'&&questionList.realAnswer=='D'&&questionList.state==0)" class="answer_li border-box right" data-type="D">
              <span class="answer_type">D</span>
              <div class="answer_info">{{question1.D}}</div>
            </div>
            <div class="answer_li border-box" data-type="D"  :class="chooseType=='D'?'curr':''" @click="chooseAnswer($event)"  v-if="(questionList.answer!='D'&&questionList.realAnswer!='D')">
              <span class="answer_type">D</span>
              <div class="answer_info">{{question1.D}}</div>
            </div>
          </div>
        </div>
        <div class="question_btn" v-if="questionList.state==0">
          <span @click="openGuidelist(guideSpotId1)">听解说 找答案</span>
        </div>
        <div class="question_btn" v-if="questionList.state==1">
          <span @click="closeQuestionBox()">确定</span>
        </div>
        <div class="question_btn" v-if="!questionList.answer&&!questionList.state">
          <span style="margin-right: .4rem;" @click="openGuidelist(guideSpotId1)">听解说 找答案</span>
          <span @click="submitAnswer(questionList.id)">提交答案</span>
        </div>
      </div>
    </div>

    <!--景点打卡列表弹窗-->
    <div class="alert_list" :class="listShow==1?'curr':''" v-show="listShow==1">
      <span class="mask" @click="listShow=0"></span>
      <div class="list_box">
        <img class="list_close" src="../../assets/icon_05.png" alt="" @click="listClose">
        <div class="list_top box border-box">
          <img class="flex list_top_img" v-lazy="shopInfo.logo" alt="">
          <div class="flex">
            <div class="list_tit hide">{{shopInfo.name}}</div>
            <div class="list_num">{{shopInfo.signs}}人打卡</div>
          </div>
        </div>
        <div class="list_ul_box" id="scollBox">
          <div class="list_ul clearfix">
            <div v-if="!signList||signList.length==0" style="color: #333;text-align: center;margin-top: .5rem;font-size: .28rem;">暂无打卡</div>
            <div class="list_li border-box" v-for="(item,index) in signList">
              <img class="img list_li_img" v-lazy="item.picture"  alt="" @click="seeImg(0,item.picture)">
              <div class="list_li_info hide2">{{item.message}}</div>
            </div>
          </div>
          <p v-show="signList.length>0" class="load-tip load-tip1" id="loadTip" style="height: auto;">{{loadText1}}</p>
        </div>
      </div>
    </div>

    <!--研学打卡弹窗-->
    <div class="alert_card" :class="cardShow==0?'none':'curr'">
      <span class="mask" @click="cardShow=0"></span>
      <div class="alert_card_box">
        <img class="close" src="../../assets/icon_05.png" alt="" @click="cardShow=0">
        <div class="card_top box border-box">
          <img class="flex card_top_img" v-lazy="shopInfo.logo" alt="">
          <div class="flex">
            <div class="card_tit hide">{{shopInfo.name}}</div>
            <div class="card_num">{{shopInfo.signs}}人研学打卡</div>
          </div>
        </div>
        <textarea class="card_textarea border-box" placeholder="说说您的打卡感言吧" v-model="cardInfo"></textarea>
        <div class="card_upload_box clearfix">
          <div class="fl card_upload"  v-for="(url,index) in imgList" v-show="imgList.length">
            <img class="upload_img" :src="url.file.src" alt="">
            <img class="upload_del" src= "../../assets/study_upload_del.png" alt="" @click.stop="delImg(index)">
          </div>
          <div v-show="imgList.length<1">
            <input @change="fileChange($event)" type="file" id="upload_file" multiple style="display: none"/>
            <img class="fl upload_img" src="../../assets/study_card_img.jpg" alt="" @click="chooseTypePic">
          </div>
        </div>
        <div class="upload_btn"  @click="sendCard" v-if="showBtn1==1">确定提交打卡</div>
      </div>
    </div>

    <!--注册弹窗-->
    <div class="alert_login" :class="loginShow==0?'none':'curr'">
      <span class="mask" @click="loginShow=0"></span>
      <div class="login_box border-box">
        <img class="close login_close" src="../../assets/icon_05.png" alt="" @click="loginShow=0">
        <div class="login_tit hide tl">为了更好的为您服务，请先绑定您的个人信息</div>
        <div class="login_li border-box" style="margin-top: .33rem;">
          <img class="login_li_icon" src="../../assets/icon_20_study.png" alt="">
          <input class="border-box" v-model="studyName" type="text" placeholder="姓名">
        </div>
        <div class="login_li border-box">
          <img class="login_li_icon" src="../../assets/icon_21_study.png" alt="">
          <input class="border-box" v-model="studyTel" type="number" placeholder="手机号">
        </div>
        <div class="login_li border-box" style="background: #fff;">
          <div class="box border-box">
            <div class="flex">
              <img class="login_li_icon" src="../../assets/icon_22_study.png" alt="">
              <input class="border-box" type="text" v-model="studyYzm" placeholder="验证码">
            </div>
            <div class="flex yzm_btn tc" :class="yzmSend==1?'disabled':''" @click="getYzm">{{yzmTxt}}</div>
          </div>
        </div>
        <button class="login_btn tc" @click="loginSubmit"  v-if="showBtn==1">确&nbsp;&nbsp;定</button>
      </div>
    </div>

  </div>


</template>

<script>
  import axios from 'axios'
  import {getServer} from '@/utils/share'
  import Qs from 'qs'
  import Swiper from '../../components/Swiper'
  import {getStudyInfo,getQuestion,getSignList,getAnswer,uploadUserBrowse,mapBagList,mapBagDetail,studyIsLogin,getTelYzm} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo, getHotCity1,playVideo,playDragSlide,creatOrder,wxImgPreview} from '@/utils/wechat'
  import {setStore, getStore, removeStore,loadMore,scollLoadMore} from '@/config/mUtils'
  import {uploadPic,uploadCard} from '@/utils/wechat'
  import Exif from 'exif-js';
  import wxConfirm from '@/wechat-messagebox/Confirm';
  import D from '@/wc-messagebox';
  import Vue from 'vue';
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        loadEnd: false, //数据加载结束则赋值为true
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        viewid: '',//景区id
        shopId:'',//景区活动ID
        spotId:'',//活动景点ID
        activityId:'',// 活动的id
        banners:[],
        mapStyle:'',//皮肤样式  0：正常皮肤 1：地图皮肤
        questionShow:0,//问题弹窗 0：隐藏 1：显示
        chooseType:'',//问题弹窗答案选项
        listShow:0,//景点打卡排行弹窗 0：隐藏 1：显示
        shopInfo:{ info: ''},//景区信息
        spotList:[],//景点信息列表
        spotListTotal:'',//景点信息列表总数
        page:1,
        rows:10,
        pageAlert:1,//弹窗内分页 page
        rowsAlert:10,//弹窗内分页 rows
        loadText: "数据加载中",
        questionList:'',//问题信息
        question1:'',//问题选项
        signList:[],//打卡列表
        cardShow:0,//打卡弹窗 0：隐藏 1：显示
        imgList: [],
        imgSrcs: [],
        size: 0,
        limit:1, //限制图片上传的数量
        tempImgs:[],
        cardInfo:'',//打卡文字内容
        isSuccess:false,//是否上传成功
        loadText1: '数据加载中', //弹窗列表提示

        slideInfoTxt:'展开详情',//展开详情按钮文字
        slideState:0,//详情展开与隐藏 0：隐藏 1：展开

        guideSpotId: '-1', //记录需要专辑列表的景点id
        guideSpotId1: '-1', //记录上一个
        guidelistShow: 0, //是否显示专辑列表
        guidelist: [], //专辑列表
        videoShow: 0, //显示语音列表
        buy: false, //是否购买
        bagid: '', //专辑id
        guideinfo: [], //导游信息
        voicelist: [], //语音列表

        Audio: '', //音频dom
        playTimer: null, //语音播放计时器
        playTime: 0, //当前播放音频的实时时间
        playing: 0, //是否在播放
        playIndex: -1, //正在播放的语音下标
        playIndex1: 0, //当前播放音频数组下标(用来记录currIndex)
        currSlider: 0, //当前进度条

        isComplete:'',//是否完成研学
        score:'',//完成研学得分

        loginState:0,//是否注册 0：未注册 1：已注册
        loginShow:0,//注册弹窗 0：已注册隐藏 1：未注册显示
        studyName: '',
        studyTel: '',
        studyYzm: '',
        yzmTxt: '验证码',
        yzmSend: 0, //0：未发送 1：已发送
        count: 59, //倒计时
        timer: null, //计时器
        isSign:'',//是否打卡  0 未打卡， 大于0 已打卡
        isRegister:'',//是否开启注册

        clientHeight:document.documentElement.clientHeight,
        showBtn: 1,  // 控制按钮盒子显示隐藏
        showBtn1: 1,  // 控制按钮盒子显示隐藏
        currMapLi:-1,//地图当前index
        isDisable:false,//开始可以点击
        liIndex:-1,//第几个问题
        flagShow:0,//红旗是否显示
        flagLeft:'',//红旗距离浏览器左侧位置
        flagTop:'',//红旗距离浏览器顶部位置
      }
    },
    computed: {},
    created(){
      let self = this;
      this.$loading.show('数据加载中');
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.userInfo = getStore("userInfo");
      this.shopId = this.$route.query.id;
//      this.isComplete = this.$route.query.isComplete;
//      this.score = this.$route.query.score;
      this.initData(this.page);
      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll", function () {});
      document.getElementById("scollBox").removeEventListener("scroll",this.handleFun1)
      if(this.playTimer){
        clearInterval(this.playTimer);
        this.playIndex = -1;
        this.Audio.pause();
        this.playing = 0;
      }
    },
    methods: {
      //初始化：获取景区数据
      async initData(page){
        this.loadEnd = false;
        let resStudyIndex = await getStudyInfo({
          TimeStamp: this.TimeStamp,
          id:this.shopId,//景区活动id
          openid:this.userInfo.openid,
          page:page,
          rows :this.rows
        });
        if(resStudyIndex.errcode == "00000"){
          this.$loading.hide();
          this.viewid = resStudyIndex.data.data.id;
          this.shopInfo = resStudyIndex.data.data;
          this.isSign = this.shopInfo.isSign;
          this.banners = [resStudyIndex.data.data.logo];
          this.spotListTotal = resStudyIndex.data.spots.total;
          this.isComplete = resStudyIndex.data.data.state;
          this.score = resStudyIndex.data.data.score;
          this.$route.meta.title = resStudyIndex.data.data.name;
          this.isRegister = resStudyIndex.data.data.is_register;
          this.mapStyle = resStudyIndex.data.data.model;
          this.activityId = resStudyIndex.data.data.plugin_id;
          let spotList = resStudyIndex.data.spots.data;
          if (page >= Math.ceil(this.spotListTotal / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (spotList.length > 0) {
            this.spotList = [...this.spotList, ...spotList];
          } else {
            if (page == 1) {
              this.spotList = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          let title = '金牌解说 | ' + resStudyIndex.data.data.name  + '景区研学活动';
          let desc = '金牌解说邀您参与文化研学，听解说！讲故事！弘扬历史文化！';
          let link = '/study-detail?id='+this.shopId+'&TimeStamp'+this.TimeStamp +'&appKey=' + this.appKey;
          wxShareme(title,desc,"",link);

          this.isLogin();
        }
      },

      async isLogin(){
        if(this.activityId!=''){
          let loginBind = await studyIsLogin({
            TimeStamp: this.TimeStamp,
            openid:this.userInfo.openid,
            id: this.activityId
          });
          if(loginBind.errcode == "00000"){
            if(loginBind.data == true){
              this.loginState = 0
            }else{
              this.loginState = 1
            }
          }else{
            this.loginState = 1
          }
          console.log('注册状态'+this.loginState);
        }

      },

      //登录注册弹窗
      loginSubmit(){
        let self = this;

        if ( (self.studyName == undefined || self.studyName == '' || self.studyName == null)) {
          self.$toast('请输入您的姓名')
          return
        }

        if (self.studyTel == undefined || self.studyTel == '' || self.studyTel == null) {
          self.$toast('请输入您的手机号码')
          return
        }
        if (!(/^1[34578]\d{9}$/.test(self.studyTel))) {
          self.$toast('手机号码格式不正确')
          return
        }
        if (self.studyYzm == undefined || self.studyYzm == '' || self.studyYzm == null) {
          self.$toast('请输入手机验证码')
          return
        }



        self.userInfo = getStore("userInfo");
        let url = "", obj = {};
        url = "plugin/bind.do";
        obj = {
          name:self.studyName,
          phone: self.studyTel,
          code: self.studyYzm,
          openid: self.userInfo.openid,
          id:self.activityId
        }


        if(self.isDisable == false){
//          console.log(self.isDisable );
          axios.post( getServer().admin + url, Qs.stringify(obj), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then(function (data) {
            self.isDisable = true
//            console.log(self.isDisable );
            if(data.data.errcode == "00000"){
              //            setStore("user", {"user":data.data.data},1);
            self.loginShow = 0;
            self.loginState = 1;

            }else {
              self.$toast(data.data.errmsg);
            }
          })
        }else{
//          console.log('return'+self.isDisable );
          return
        }



      },

      //获取手机验证码
      async getYzm(){
        let self = this;
        if(self.yzmSend == 1){
          return;
        }
        if (self.studyTel == undefined || self.studyTel == '' || self.studyTel == null) {
          self.$toast('请输入您的手机号码')
          return
        }
        if (!(/^1[34578]\d{9}$/.test(self.studyTel))) {
          self.$toast('手机号码格式不正确')
          return
        }

        let res = await getTelYzm({
          TimeStamp: self.TimeStamp,
          phone: self.studyTel
        });
        if(res.errcode == "00000"){
          self.$toast('发送成功请稍等');
          self.yzmSend = 1;

          self.timer = setInterval(self.CountDown, 1000);
        }

      },
      CountDown(){
        this.yzmTxt = "重新发送(" + this.count + ")";
        if (this.count<= 0) {
          clearInterval(this.timer);
          this.yzmSend = 0;
          this.yzmTxt = "获取验证码";
        }
        this.count--;
      },

      //答题弹窗
      async questionFun(id,state,index){
        if(index>=0){
          this.liIndex = index;
        }
//        console.log(this.liIndex);
        if(this.loginState == 0 && this.isRegister == 1){
          this.loginShow = 1;
          this.isLogin();
        }else{
            this.questionList=[] ;

            this.spotId = id
            let questionInfo = await getQuestion({
              id:id,//活动景点id
              openid:this.userInfo.openid,
              state: state
            });
            if(questionInfo.errcode == "00000"){
              if(questionInfo.data.question!=null&&questionInfo.data.question!=''&&questionInfo.data.question!=undefined){
                this.questionShow = 1;
                this.questionList = questionInfo.data.question;
                this.question1 = JSON.parse(this.questionList.answers);
              }else{
                this.$toast("暂无问题");
              }
            }

        }

      },

      //打卡列表
      async signListFun(page){
        this.listShow = 1;
        let signListInfo = await getSignList({
          TimeStamp: this.TimeStamp,
          id:this.shopId,
          page:page,
          rows :this.rowsAlert
        });
        if(signListInfo.errcode == "00000"){
          this.$loading.hide();
          let signList = signListInfo.data.data;
          if (page >= Math.ceil(signListInfo.data.total / this.rowsAlert)) {
            this.loadText1 = '已经到底了'
          } else {
            this.loadText1 = '加载更多'
          }
          if (signList.length > 0) {
            this.signList = [...this.signList, ...signList];
          } else {
            if (page == 1) {
              this.signList = [];
              this.loadText1 = '暂无数据'
            } else {
              this.loadText1 = '已经到底了'
            }
          }
        }else {
          this.$loading.hide();
        }
      },

      //打卡列表隐藏
      listClose(){
        this.pageAlert = 1;
        this.signList = [];
//        this.signListFun(this.pageAlert);
        this.listShow = 0;
      },

      //详情展示与隐藏
      slideInfo(){
        if(this.slideState == 0){
          this.slideState =1
          this.slideInfoTxt = '隐藏详情'
        }else{
          this.slideState =0
          this.slideInfoTxt = '展开详情'
        }
      },



      //答案选择
      chooseAnswer(e){
        if(this.questionList.state==0||this.questionList.state==1){
          this.chooseType = '';
        }else{
          this.chooseType = e.currentTarget.dataset.type;
        }

      },
      //关闭答案选择弹窗
      closeAnswer(){
        this.chooseType = "";
        this.questionShow = 0;
        this.guideSpotId = -1;
      },
      //打完问题后关闭答案选择弹窗
      closeQuestionBox(){
        this.questionShow = 0;
      },


      //提交答案
      async submitAnswer(id){
        var self = this;
        if(self.chooseType == '' || self.chooseType == 'null'){
          self.$toast("请选择答案",{ location: ''})
          return
        }
        let answerInfo = await getAnswer({
          TimeStamp: self.TimeStamp,
          id:id,// 景点问题id
          openid:self.userInfo.openid,
          answer:self.chooseType,//用户选择的答案
          pluginShopId :self.shopId,// 景区活动id
        });
        if(answerInfo.errcode == "00000"){
//          self.signList = signListInfo.data.data;
          self.questionFun(self.spotId,1);
//          self.spotList= [];
//          self.page = 1;
//          self.initData(self.page);
//          console.log(self.page)
          self.chooseType = "";
          if(answerInfo.data.shopIsComplete==true){
            self.isComplete = 1;
            self.score = answerInfo.data.shopScore;
          }


//          console.log(self.liIndex);
          if(answerInfo.data.state == true){
            self.spotList[self.liIndex].state=1;
            self.spotList[self.liIndex].answer=1;
            self.spotList[self.liIndex].total++;
          }else{
            self.spotList[self.liIndex].state=1;
            self.spotList[self.liIndex].answer=0;
            self.spotList[self.liIndex].total++;
          }
        }

      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      handleFun1: function (){
        let self = this;
        self.$nextTick(function() {
          scollLoadMore(self,'scollBox','loadTip',function(){
            self.pageAlert += 1;
            self.signListFun(self.pageAlert);
          });
        })
      },


      //上传图片
      chooseTypePic(){
        document.getElementById('upload_file').click();
      },
      fileChange(el){
        if (!el.target.files[0].size) return;
        this.fileList(el.target);
        el.target.value = ''
      },
      fileList(fileList){
        let files = fileList.files;
        for (let i = 0; i < files.length; i++) {
          //判断是否为文件夹
          if (files[i].type != '') {
            this.fileAdd(files[i]);
          } else {
            //文件夹处理
            this.folders(fileList.items[i]);
          }
        }
      },
      //文件夹处理
      folders(files){
        let self = this;
        //判断是否为原生file
        if (files.kind) {
          files = files.webkitGetAsEntry();
        }
        files.createReader().readEntries(function (file) {
          for (let i = 0; i < file.length; i++) {
            if (file[i].isFile) {
              self.foldersAdd(file[i]);
            } else {
              self.folders(file[i]);
            }
          }
        });
      },
      foldersAdd(entry){
        let self = this;
        entry.file(function (file) {
          self.fileAdd(file)
        })
      },
      fileAdd(file){
        let self = this;
        let Orientation;
        Exif.getData(file, function(){
          Orientation = Exif.getTag(this, 'Orientation');
        });

        if (this.limit !== undefined) this.limit--;
        if (this.limit !== undefined && this.limit < 0) return;
        //总大小
        this.size = this.size + file.size;
        //判断是否为图片文件
        if (file.type.indexOf('image') == -1) {
          this.$toast("请先选择答案");
        } else {
          let reader = new FileReader();
          let image = new Image();
          reader.readAsDataURL(file);
          reader.onload = function () {
            file.src = this.result;

            //判断图片是否小于150K,是就直接上传，反之压缩图片
            image.src = file.src;
            if(this.result.length <= (150 * 1024)){
              image.onload = function () {
                file.width = image.width;
                file.height = image.height;
                self.imgList.push({file});
                self.imgSrcs[self.imgSrcs.length] = image.src;
              };
            }else {
              image.onload = function () {
                file.width = image.width;
                file.height = image.height;
                self.imgList.push({file});
                let data = self.compress(image,Orientation);
                self.imgSrcs[self.imgSrcs.length] = data;
              };
            }
          }
        }
      },
      delImg(index){
        this.size = this.size - this.imgList[index].file.size;//总大小
        this.imgList.splice(index, 1);
        this.imgSrcs.splice(index, 1);
        if (this.limit !== undefined) this.limit = 6 - this.imgList.length;
      },
      rotateImg (img, direction,canvas) {
    //最小与最大旋转方向，图片旋转4次后回到原方向
    const min_step = 0;
    const max_step = 3;
    if (img == null)return;
    //img的高度和宽度不能在img元素隐藏后获取，否则会出错
    let height = img.height;
    let width = img.width;
    let step = 2;
    if (step == null) {
      step = min_step;
    }
    if (direction == 'right') {
      step++;
      //旋转到原位置，即超过最大值
      step > max_step && (step = min_step);
    } else {
      step--;
      step < min_step && (step = max_step);
    }
    //旋转角度以弧度值为参数
    let degree = step * 90 * Math.PI / 180;
    let ctx = canvas.getContext('2d');
    switch (step) {
      case 0:
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0);
        break;
      case 1:
        canvas.width = height;
        canvas.height = width;
        ctx.rotate(degree);
        ctx.drawImage(img, 0, -height);
        break;
      case 2:
        canvas.width = width;
        canvas.height = height;
        ctx.rotate(degree);
        ctx.drawImage(img, -width, -height);
        break;
      case 3:
        canvas.width = height;
        canvas.height = width;
        ctx.rotate(degree);
        ctx.drawImage(img, -width, 0);
        break;
    }
  },
      compress(img,Orientation) {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext('2d');
        //瓦片canvas
        let tCanvas = document.createElement("canvas");
        let tctx = tCanvas.getContext("2d");
        let initSize = img.src.length;
        let width = img.width;
        let height = img.height;
        //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        let ratio;
        if ((ratio = width * height / 4000000) > 1) {
          ratio = Math.sqrt(ratio);
          width /= ratio;
          height /= ratio;
        } else {
          ratio = 1;
        }
        canvas.width = width;
        canvas.height = height;
        //        铺底色
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //如果图片像素大于100万则使用瓦片绘制
        let count;
        if ((count = width * height / 1000000) > 1) {
          count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
          //            计算每块瓦片的宽和高
          let nw = ~~(width / count);
          let nh = ~~(height / count);
          tCanvas.width = nw;
          tCanvas.height = nh;
          for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
              tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
          }
        } else {
          ctx.drawImage(img, 0, 0, width, height);
        }
        //修复ios上传图片的时候 被旋转的问题
        if(Orientation != "" && Orientation != 1){
          switch(Orientation){
            case 6://需要顺时针（向左）90度旋转
              this.rotateImg(img,'left',canvas);
              break;
            case 8://需要逆时针（向右）90度旋转
              this.rotateImg(img,'right',canvas);
              break;
            case 3://需要180度旋转
              this.rotateImg(img,'right',canvas);//转两次
              this.rotateImg(img,'right',canvas);
              break;
          }
        }
        //进行最小压缩
        let ndata = canvas.toDataURL('image/jpeg', 0.2);
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        return ndata;
      },

      //上传打卡内容
      sendCard(){
        let self = this;
        if(this.cardInfo=='' || this.cardInfo == null){
          this.$toast('请先输入内容');
          this.isSuccess = false;
        }else if(this.imgSrcs.length < 1){
          this.$toast('请上传图片');
          this.isSuccess = false;
        }else{
          this.$loading.show('提交打卡中');
          if(this.imgSrcs.length > 0){
            uploadPic(this.imgSrcs,function(res){
              if(res.data.errcode == "00000"){
                self.uploadEnd(res.data.data.data);
              }else {
                self.$loading.hide();
                this.isSuccess = false;
                self.$toast('图片上传出错')
              }
            });
          }else {
            self.uploadEnd('');
          }
        }

      },

      uploadEnd(imgs){
        let self = this;
        uploadCard(this.shopId,imgs,this.cardInfo,function(res){
          self.$loading.hide();
          self.isSuccess = false;
          if(res.data.errcode == "00000"){
            self.$toast('打卡成功');
            self.cardInfo = '';
            self.imgList = [];
            self.imgSrcs = [];
            self.cardShow = 0;
            ++self.shopInfo.signs;
            self.isSign = 1;
          }else {
            self.$toast(res.data.message);
            self.cardShow = 0;
          }
        })
      },

      //专辑列表
      async getGuidelist(){
        let res = await mapBagList({
          openid: this.userInfo.openid,
          shopid: this.viewid,
          spotid: this.guideSpotId || '',
          cid: 0
        });

        this.guidelist = [];
        if (res.errcode === "00000"){
          this.$loading.hide();
          if(res.data.length > 0){
            this.guidelist = res.data;
            this.guidelistShow = 1
            this.questionShow = 0;
          }else {
            this.$toast('当前景点暂无解说')
          }
        }else {
          this.$loading.hide();
          this.$toast(res.errmsg)
        }
      },

      //打开专辑列表
      openGuidelist: function (id){
        if(this.guideSpotId != id ){
          this.$loading.show('数据加载中');
          this.guideSpotId = id;
          this.getGuidelist();
        }else {
          if(this.guidelist.length==0){
            this.$toast('当前景点暂无解说')
          }else {
            if(this.guidelistShow == 1){
              this.guidelistShow = 0
            }else {
              this.guidelistShow = 1
              this.questionShow = 0;
            }
          }
        }

      },

      //进入导游详情
      openGuide: function (id){
        if(this.bagid != id){
          if(this.playTimer){
            clearInterval(this.playTimer);
            this.playIndex = -1;
            this.Audio.pause();
            this.playing = 0;
          }

          this.$loading.show('数据加载中');
          this.videoShow=1;

          this.guideinfo = {};
          this.voicelist = [];
          this.bagid = id;
          this.getVideoinfo();
        }else {
          this.videoShow=1;
          this.scollToDom('voice-list-p'+this.guideSpotId)
        }
      },

      //请求导游专辑详情
      async getVideoinfo(){
        let res = await mapBagDetail({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          id: this.bagid
        });
        if (res.errcode === "00000"){
          this.$loading.hide();
          this.buy = (res.data.bag.isbuy == true || res.data.bag.isguide == true || res.data.bag.price == 0) ? true : false;
          this.guideinfo = res.data.bag;
          this.voicelist = res.data.voiceList;

          if(this.buy==true){
            if(this.guideSpotId != ''){
              this.playIndex1 = this.getIndex(this.voicelist,this.guideSpotId);
            }
          }
          this.playTime = this.voicelist[this.playIndex1].totaltime;

          let self = this;
          self.scollToDom('voice-list-p'+self.guideSpotId)
          self.$nextTick(function(){
            setTimeout(function(){
              if(!self.Audio){
                self.Audio = document.getElementById('Audio');
                self.Audio.src = self.voicelist[self.playIndex1].url;
                self.Audio.preload = "auto";
              }
              if(self.buy==true){
                playDragSlide(self);
              }
            },800)
          })
        }else {
          this.$loading.hide();
        }
      },

      //拿到数组中指定spotid的下标
      getIndex(arr,spotid){
        let result;
        if(arr.find(function(x) {return x.spotid == spotid;}) != undefined) {
          arr.find(function(x,i) {
            if(x.spotid == spotid){
              result =  i;
            }
          });
          return result;
        }else {
          return 0;
        }
      },

      //页面滑动到指定标签id位置
      scollToDom(elmid){
        let self = this;
        self.$nextTick(function(){
          setTimeout(function(){
            if(document.getElementById(elmid)){
              document.getElementById("scollBox0").scrollTo(0,parseInt(document.getElementById(elmid).offsetTop-document.getElementById("scollBox0").offsetTop-10));
            }
          },500)
        })
      },

      //点击语音收听
      playVideoClick(index){
        if(this.buy == true || index <= 1){
          playVideo(this,index);
        }else {
          this.$toast('请先购买该张专辑')
        }
      },

      //点击上一曲
      prevPlay(){
        let playIndex = this.playIndex == 0 ? (this.voicelist.length -1) : (parseInt(this.playIndex) - 1);
        playVideo(this,playIndex);
      },
      //点击下一曲
      nextPlay(){
        let playIndex = (this.playIndex == this.voicelist.length -1) ? 0 : (parseInt(this.playIndex) + 1);
        playVideo(this,playIndex);
      },

      //点击购买，调用下订单公用方法
      buyVideo(){
        let self = this;
        setStore("source", {"source": "map"});
        creatOrder(this,this.guideinfo,"",function(data){
          if(data){
            self.buy = true;
            self.$nextTick(function(){
              setTimeout(function(){
                playDragSlide(self);
              },500)
            });
          }
        },true)

      },

      //图片预览
      seeImg(ind,imgs){
        let arr = [];
        arr.push(imgs);
        wxImgPreview(imgs,arr);
      },

      //地图点击事件
      clickMapLi(index,e){
        this.currMapLi=index;
        var liId = e.c
        this.flagTop = document.getElementById("spotLiTop"+this.spotList[index].id).offsetTop + 'px';
    console.log(document.getElementById("spotLiTop"+this.spotList[index].id).offsetTop);
        this.flagShow = 1;
        if(index%2==0){
          this.flagLeft='2%';
        }else{
          this.flagLeft='80%';
        }
        e.stopPropagation();
      },


      //地图点击事件移除curr类名
      removeCurr(){
        this.currMapLi=-1;
        this.flagShow = 0;
      },

    },
    watch:  {
      listShow(newVal,oldVal){
        if(newVal == 1){
          document.getElementById("scollBox").addEventListener("scroll",this.handleFun1)
        }else {
          document.getElementById("scollBox").removeEventListener("scroll",this.handleFun1)
        }
      }
    },
    components: { Swiper,},
    //格式化数据
    filters: {
      //格式化数字
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      }
    },
    mounted() {
      window.onresize= ()=>{
        if(this.clientHeight>document.documentElement.clientHeight) {
          this.showBtn =0
          this.showBtn1 =0
        }else{
          this.showBtn = 1
          this.showBtn1 = 1
        }
      }
    }
  }

</script>

<style scoped>
  .page{padding-bottom:0;background: #efefef;}
  .page_box{padding-bottom:1rem;}
  .banner{position:relative;width: 100%;height: 3.5rem;background: url(../../assets/study_bg.png) no-repeat center;background-size: 100% auto;}
  .swiper-box{border-radius: 0;}
  .map_close{display: none;}
  .spot_ul{padding:0 .28rem;margin-top: -.54rem;}
  .spot_li{position: relative;z-index: 5;padding:.35rem .32rem .22rem;margin-bottom:.3rem;border-radius: .1rem;}
  .spot_li:after{content: '';position: absolute;bottom:-.3rem;left: .35rem;width: .08rem;height:.3rem;background: #bbb4af;}
  .spot_li:last-child:after{display: none;}
  .complete_score{position:absolute;top:.4rem;right:.3rem;padding: .12rem .24rem;font:bold .28rem/.34rem "Microsoft YaHei";letter-spacing:.02rem;color: #fe6302;text-align: center;-webkit-transform: rotate(-24deg);transform: rotate(-24deg);}
  .complete_score img{position: absolute;top:0;left: 0;width: 100%;height: 100%;object-fit: cover;}
  .spot_name{position: relative;height: .34rem;padding-left:.2rem;font:bold .32rem/.34rem "Microsoft YaHei";border-left: .09rem solid #b1e088;color: #333;}
  .spot_sub{height:.8rem;margin-top: .12rem;font: .22rem/.4rem "Microsoft YaHei";color: #3d3d3d;}
  .spot_sub.curr{ height:auto }
  @keyframes spotSub {from{height:.8rem;}to{height:auto;}}

  .spot_bot{height: .54rem;line-height: .54rem;margin-top: .18rem;font-size: .24rem;color: #676767;}
  .spot_icon{width: auto;height: .39rem;margin-top: .075rem;margin-right: .14rem;}
  .spot_bot span{margin-left:.09rem;color: #f46404;}
  .spot_bot .spot_btn{height:.54rem;line-height:.54rem;padding:0 .2rem;background: -webkit-linear-gradient(top,#fea065,#f56b5a);background: linear-gradient(to bottom,#fea065,#f56b5a);border-radius: .3rem;font-size: .24rem;color: #fff;}
  .spot_bot .spot_btn.is_spot_btn{background: #b0b0b0;}
  .spot_btn img{float:left;width: auto;height: .25rem;margin-top: .14rem;margin-right: .08rem;}
  .spot_question{height: 1.8rem;padding: .15rem .16rem;}
  .spot_question img.flex{width: 2.2rem;height: 100%;margin-right:.21rem;object-fit: cover;border-radius: .1rem;}
  .spot_q_top{height:.46rem;font: bold .28rem/.46rem "Microsoft YaHei";color: #333;}
  .spot_q_top div.name{max-width: 72%;}
  .spot_q_top div.num{ position: relative;z-index: 3;margin-left: .12rem;font: 500 .2rem/.46rem "Microsoft YaHei";color: #525252;text-align: right;}
  .spot_q_bot{margin-top: .52rem;}
  .spot_q_bot span{display: inline-block;width: 46%;height: .48rem;font: .24rem/.48rem "Microsoft YaHei";border: .01rem solid #f56b5a;text-align: center;border-radius: .02rem;}
  .spot_q_bot span.spot_q_btn1{color: #f56b5a;}
  .spot_q_bot .spot_q_btn1 img{width: auto;height: .25rem;margin-left: .1rem;vertical-align: middle;}
  .spot_q_bot span.spot_q_btn2{color: #fff;font-weight: bold;background: #f56b5a;}
  .fix_btn{position: fixed;left: .28rem;right: .28rem;bottom: 0;height: .89rem;line-height: .89rem;font-size: .36rem;color: #fff;text-align: center;letter-spacing: .12rem;border-radius: .12rem .12rem 0 0;background: -webkit-linear-gradient(top,#fea065,#f56b5a);background: linear-gradient(to bottom,#fea065,#f56b5a);z-index: 5; }


  /*地图样式*/
  .page_box.map_style{min-height:100vh;padding-top:1rem;}
  .page_box.map_style.spot_ul{margin-top: 0;}
  .page_box.map_style .map_close{display:none;position: absolute;z-index: 6;left: 0;top: 1.15rem;width: .3rem;height: .3rem;padding: .08rem;background: #fff;border-radius: 50%;}
  .page_box.map_style .spot_li_box.curr .map_close{display: block;}
  .page_box.map_style .spot_ul .spot_li_box{position: relative;}
  .page_box.map_style .spot_ul .spot_li_box:nth-of-type(2){margin-top: .8rem;}
  .page_box.map_style .spot_ul .spot_li:after{display: none!important;}
  .page_box.map_style .map_con{position: relative;display: block;width: 3rem;height: 2.88rem;margin-bottom: .7rem;margin-left: .16rem;}
  .page_box.map_style .icon_complete{position: absolute;right: .12rem;top: 50%;width: .8rem;height: auto;-webkit-transform: translateY(-50%); transform: translateY(-50%);}
  .page_box.map_style .spot_li_box:nth-of-type(2n) .map_con{float: left;}
  .page_box.map_style .spot_li_box:nth-of-type(2n+1) .map_con{float: right;}
  .page_box.map_style .spot_li_box:nth-of-type(2n+1) .map_con .map_bot {right:.85rem;left: inherit;}
  .page_box.map_style .map_con .map_logo{position: absolute;top:50%;left: 50%;width: 3rem;height: 2.88rem;margin-top:-1.44rem;margin-left: -1.5rem;
    -webkit-mask-image: url(https://filewc.geeker.com.cn/%E9%87%91%E7%89%8C%E8%A7%A3%E8%AF%B4%E5%B0%8F%E7%A8%8B%E5%BA%8F/mask_map.png);
    mask-image: url(https://filewc.geeker.com.cn/%E9%87%91%E7%89%8C%E8%A7%A3%E8%AF%B4%E5%B0%8F%E7%A8%8B%E5%BA%8F/mask_map.png);
    -webkit-mask-box-image: url(https://filewc.geeker.com.cn/%E9%87%91%E7%89%8C%E8%A7%A3%E8%AF%B4%E5%B0%8F%E7%A8%8B%E5%BA%8F/mask_map.png);
    mask-box-image: url(https://filewc.geeker.com.cn/%E9%87%91%E7%89%8C%E8%A7%A3%E8%AF%B4%E5%B0%8F%E7%A8%8B%E5%BA%8F/mask_map.png);
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
    z-index: 3; }
  .page_box.map_style .map_con .map_logo_bg{position: absolute;top:50%;left: 50%;width: 3rem;height: 2.88rem;margin-top:-1.44rem;margin-left: -1.5rem; -webkit-transform:translate(0,.038rem) scale(1.22);transform:translate(0,.038rem) scale(1.22);}
  .page_box.map_style .map_con .map_bot{position: absolute;z-index:4;left:1.06rem;bottom:-.4rem;width: 2.56rem;height:1.2rem;padding:.18rem .24rem;background:#fff;border-radius: .16rem;box-shadow: 0 0 .15rem #656551;}
  .page_box.map_style .map_bot .map_bot_t{font: bold .3rem "Microsoft YaHei";color: #000;}
  .page_box.map_style .map_bot .map_bot_b{margin-top:.12rem;font: .24rem/.36rem "Microsoft YaHei";color: #ff9102;}
  /*.icon_flag{display:none;position: absolute;right:-.13rem;top:-1rem;width: 1.44rem;height: 1.27rem;opacity: 0;}*/
  /*.page_box.map_style .spot_li_box.curr .icon_flag{display:block;-webkit-animation:flag .5s linear;animation:flag .8s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards; }*/
  .page_box.map_style .map_con .map_bot_b img{width: .32rem;height: .32rem;margin-top: .02rem;margin-right: .12rem;}
  .page_box.map_style .spot_ul .spot_li_box .spot_li{display: none!important;position: absolute;top:1.62rem;left: 0;}
  .page_box.map_style .spot_ul .spot_li_box.curr .spot_li{ display: -webkit-box!important; display: box!important;}
  @-webkit-keyframes flag {0%,40%,80%{opacity: 0;}20%,60%,100%{opacity: 1;}}
  @keyframes flag {0%,25%,75%{opacity: 0;}50%,100%{opacity: 1;}}
  .page_box.map_style .load-tip{color: #fff;}

  .icon_flag{position: absolute;z-index: 6;width:1.54rem;height:auto;-webkit-transition: all ease .8s;transition: all ease .8s;-webkit-transform: translateY(-30%);transform: translateY(-30%);}

  /*弹窗*/
  .alert_question,.alert_list,.alert_card,.alert_login {position: fixed;z-index: 6;top:0;left: 0;width: 100vw;height: 100vh;}
  .mask,.alert_question .mask,.alert_list .mask,.alert_card .mask{position: absolute;top:0;left: 0;width: 100vw;height: 100vh;background: rgba(0,0,0,.69);}
  .alert_list.curr .list_box{animation:slideUpAlert .3s linear;animation-fill-mode:forwards;}
  /*问题弹窗*/
  .question_box{position: absolute;left: 7%;top: 50%;width:86%;padding: 1rem .58rem .36rem;background: #fff;border-radius: .22rem;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .question_logo{position: absolute;top:-.14rem;left:50%;height: .67rem;padding: 0 .4rem;-webkit-transform: translateX(-50%);transform: translateX(-50%);font: .32rem/.67rem "Microsoft YaHei";color: #fff;background: #f56b5a;border-radius: 0 0 .24rem .24rem;}
  .question_close{position: absolute;top:.34rem;right: .37rem;width: .3rem;height: .3rem;z-index: 1;}
  .question_tit{font:bold .27rem/.36rem "Microsoft YaHei";color: #000;text-align: center; }
  .question_btn{width:100%;margin-top: .4rem;text-align: center;}
  .question_btn span{display: inline-block;width: 2.4rem;height: .77rem;font: bold .32rem/.77rem "Microsoft YaHei";color: #fff;border-radius: .16rem;background: -webkit-linear-gradient(top,#fea065,#f56b5a);background: linear-gradient(to bottom,#fea065,#f56b5a);text-align: center;}
  .answer{margin-top: .5rem;}
  .answer_li{position: relative;min-height:1rem;padding: .3rem .26rem .3rem 1.33rem;margin-bottom:.2rem;font: bold .28rem/.4rem "Microsoft YaHei";color: #3f3c3d;background: #f9f9f9;border-radius: .1rem; }
  .answer_type{position: absolute;left: .26rem;top:50%;width: .65rem;height: .65rem;margin-top:-.325rem;text-align: center;font: bold .36rem/.65rem "Microsoft YaHei";color: #fff;border-radius: 50%;background: #313131;}
  .answer_li.curr{background: #ffddd9;}
  .answer_li.curr .answer_type{background: #f56b5a;}
  .answer_li.error{background: #fdf3f4;padding-right: .67rem;}
  .answer_li.error .answer_type{background: #ff2e5e;}
  .answer_li.error:after{content:'';position: absolute;top:50%;right:.36rem;width: .33rem;;height: .33rem;margin-top: -.165rem;background: url(../../assets/icon_cuo1_study.png) no-repeat center;background-size: contain;}
  .answer_li.right{background: #f3fdf9;}
  .answer_li.right .answer_type{background: #a5ca0f;}
  .answer_li.right:after{content:'';position: absolute;top:50%;right:.36rem;width: .33rem;;height: .33rem;margin-top: -.165rem;background: url(../../assets/icon_dui1_study.png) no-repeat center;background-size: contain;}


  /*打卡弹窗*/
  .list_box{position: absolute;top:1.2rem;left: .26rem;right: .26rem;bottom: 0;border-radius: .18rem .18rem 0 0;background: #fff;}
  .list_close{position: absolute;top:.38rem;right: .34rem;width: .3rem;height: .3rem;z-index: 1;}
  .list_top{padding: 0 .24rem .4rem;}
  .list_top_img{width:1.58rem;height:1.58rem;margin-top: -.46rem;margin-right:.24rem;border-radius: .1rem;object-fit: cover;}
  .list_tit{margin-top: .3rem;font: bold .32rem "Microsoft YaHei";color: #0f0f0f;}
  .list_num{margin-top: .1rem;font: bold .22rem "Microsoft YaHei";color:#221815;}
  .list_ul_box{ position: absolute;bottom: 0;top: 1.6rem;left: 0;width: 100%;overflow-y: scroll;padding-bottom: .4rem;}
  .list_ul{width: 100%;}
  .list_li{float: left;position:relative;width: 50%;height: 3.48rem;}
  .list_li:before{content:'';position: absolute;top:0;left:0;right:0;height: .02rem;background: #fbfbfb;}
  .list_li:nth-of-type(2n+1){padding: .4rem .23rem .4rem .26rem;}
  .list_li:nth-of-type(2n){padding: .4rem .26rem .4rem .23rem ;}
  .list_li_img{width: 100%;height: 2rem;object-fit: cover;}
  .list_li_info{margin-top: .1rem;font: .24rem/.32rem "Microsoft YaHei";color: #333;}

  /*打卡弹窗*/
  .close{position: absolute;top:.4rem;right: .34rem;width: .3rem;height: .3rem;z-index: 1;}
  .alert_card_box{position: absolute;left: .26rem;right: .26rem;bottom: -70%;padding:0 .24rem .27rem .24rem;border-radius: .18rem .18rem 0 0;background: #fff;}
  .card_top{padding: 0 .24rem;}
  .card_top_img{width:1.58rem;height:1.58rem;margin-top: -.46rem;margin-right:.24rem;border-radius: .1rem;object-fit: cover;}
  .card_tit{margin-top: .3rem;padding-right:.5rem;font: bold .32rem "Microsoft YaHei";color: #0f0f0f;}
  .card_num{margin-top: .1rem;font: bold .22rem "Microsoft YaHei";color:#221815;}
  .card_textarea{display: block;width:100%;height: 2.16rem;margin-top: .3rem;padding: .2rem .14rem;font: .24rem/.32rem "Microsoft YaHei";color: #868686;background: #fafafa;}
  .card_upload_box{margin-top: .68rem;}
  .card_upload_box .upload_img,.card_upload{position:relative;width: 1.32rem;height: 1.32rem;object-fit: cover;}
  .card_upload{margin-right:.24rem;}
  .upload_del{position: absolute;top:-.12rem;right:-.12rem;width: .24rem;height: .24rem;}
  .upload_btn{margin-top: .93rem;height: .85rem;font: bold .3rem/.85rem "Microsoft YaHei";color: #fff;text-align: center;background: #f9b544;letter-spacing: .05rem;}

  /*弹窗动画*/
  .alert_card.curr{display: block;}
  .alert_card.curr .alert_card_box{-webkit-animation: slideUP .3s linear;animation: slideUP .3s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  @-webkit-keyframes slideUP{ from{bottom:-70%;}to{bottom:0%;}}
  @keyframes slideUP{ from{bottom:-70%;}to{bottom:0%;}}

  .slide_info{ color: #f46404; text-align: center; font-size: .2rem; padding: .2rem 0; }

  /*专辑列表*/
  .spot-close{ position: absolute; right: .25rem; top: .22rem; z-index: 3; padding: .05rem; width: .29rem; height: .29rem; }
  .spot{ position: fixed; left: .24rem; right: .24rem; bottom: 1.13rem; z-index: 3; background-color: #fff; box-shadow: 0 .05rem .09rem rgba(102,102,102,.1); border-radius: .15rem; }
  .spot .guide-info{ position: relative;padding-top: .25rem; height: .6rem; padding-left: .22rem; padding-right: .66rem; }
  .spot .guide-info > h3{ font: bold .28rem/.4rem "Microsoft YaHei"; color: #333;  }
  .spot-guide{ padding-bottom: .07rem; box-shadow: 0 -.07rem .13rem rgba(231,231,231,.3); border-radius: .08rem .08rem 0 0; }
  .spot-scoll{ width: 100%; padding-left: .25rem; padding-top: .15rem; overflow: hidden; }
  .scoll-list{ width: auto; height: 2.42rem; overflow-x: auto; overflow-y: hidden; white-space: nowrap;display: -webkit-box; display: flex; }
  .list-li{ float: left; margin-right: .28rem; width: 1.65rem; }
  .list-li:last-child{  padding-right: .28rem; }
  .list-li-img{ position: relative; width: 1.65rem; height: 1.65rem; border-radius: .1rem; overflow: hidden; }
  .list-li-img .gif{ position: absolute; left: 0; right: 0; top: 0; bottom: .35rem; width: 100%; background-color: rgba(0,0,0,.5); }
  .list-li-img .gif img{ position: absolute; left: 50%; top: 48%; margin-left: -.105rem; width: .21rem; height: .22rem; }
  .list-li-img p{ position: absolute; left: 0; bottom: 0; width: 100%; height: .35rem; line-height: .35rem; font-size: .18rem; color: #fffefe; background-color: rgba(0,0,0,.5); }
  .list-li-img p img{ margin: 0 .09rem; width: .19rem; height: .16rem; vertical-align: text-top; }
  .list-li > h3{ margin-top: .02rem; line-height: .3rem; font-size: .24rem; color: #3d3d3d; }
  .list-li > p{ line-height: .3rem; font-size: .16rem; color: #3d3d3d; font-weight: bold; }

  /*导游+语音弹窗*/
  .toast{ position: fixed; left: 0; top: 0; z-index: 6; width: 100%; height: 100%; background-color: rgba(0,0,0,.5);  }
  .voice-box{ position: absolute; left: .24rem; right: .24rem; bottom: 0; z-index: 1; background-color: #fff; border-radius: .12rem .12rem .05rem .05rem; }
  .guide{ position: relative; width: 100%; height: 2.2rem; box-shadow: 0 .1rem .15rem rgba(102,102,102,.1); }
  .toast-close{ position: absolute; right: .25rem; top: .14rem; z-index: 3; padding: .05rem; width: .29rem; height: .29rem; }

  /*未购买*/
  .guide-box{ position: relative; z-index: 2; padding: .22rem .22rem .25rem; }
  .guide-img{ position: relative; width: 1.58rem; height: 1.58rem; border-radius: .1rem; overflow: hidden; }
  .guide-info{ position: relative; height: 1.58rem; padding-left: .22rem; padding-right: .66rem; }
  .guide-info > h3{ font: bold .32rem/.4rem "Microsoft YaHei"; color: #0f0f0f;  }
  .guide-info > p{ margin-top: .13rem; font: .22rem/.24rem "Microsoft YaHei"; color: #221815; }
  .guide-lable{ margin-top: .2rem; }
  .guide-lable p{ line-height: .32rem; font-size: .18rem; color: #666;  }
  .guide-lable p img{ width: auto; height: .19rem; vertical-align: text-top;  }
  .guidebtn{ position: absolute; right: 0; bottom: -.11rem; width: 1.8rem; height: .57rem; line-height: .57rem; font-size: .26rem; color: #fff; background:linear-gradient(to right, #fccd5b , #faaf39); border-radius: .16rem; }

  /*已购买*/
  .guide1{ height: 2.8rem; }
  .guide1 .bg{ position: absolute; left: -.12rem; top: .6rem; right: -.12rem; z-index: 1; height: 1.87rem; border-radius: .06rem; box-shadow: 0 .1rem .15rem rgba(255,204,84,.7); background:linear-gradient(to right, rgba(255,194,49,.9) , rgba(255,168,32,.9)); }
  .guide1 .guide-box{ padding: .26rem .16rem 0; }
  .guide1 .guide-img{ width: 1.78rem; height: 1.79rem; margin-top: .05rem; }
  .guide-voice{ position: relative; padding-left: .15rem; }
  .guide-tit{ margin-top: .45rem; font-size: .28rem; color: #fff; }
  .guide-slider{ position: relative; padding-right: .85rem; margin-top: .18rem; height: .30rem; }
  .guide-slider-left{ position: relative; width: 88%; margin: 0 auto; padding-top: .12rem; }
  .guide-slider-left p{ position: relative; width: 100%; height: .07rem; background-color: #eaebec; border-radius: .05rem; }
  .guide-slider-left p span{ position: absolute; left: 0; top: 0; z-index: 1; width: 100%; height: .07rem; background-color: #414141; border-radius: .05rem; }
  .guide-slider-left p i{position: absolute; left: 0; top: -.25rem; z-index: 1; margin-left: -.35rem; width: .8rem; height: .533rem; background: url(../../assets/icon_play_btn12.png) no-repeat; background-size: 100% 100%; }
  .guide-slider-right{ position: absolute; right: .1rem; top: 0; z-index: 1; height: .30rem; font: .22rem/.30rem "Microsoft YaHei"; color: #fff; }
  .guide-btn1{ margin-top: .25rem; height: .34rem; }
  .guide-btn1 img{ display: inline-block; padding-right: .3rem; width: .34rem; height: .34rem; }
  .guide-btn1 .play{ padding-right: .35rem; margin-left: .23rem; margin-right: .25rem; }

  .guide-scoll{ width: 100%; height: calc(100vh - 3.3rem); overflow-y: auto; }
  .scoll-tab{ padding: .01rem 0 .25rem; }
  /*语音列表*/
  .voice-list{ padding: 0 .35rem 0 .28rem; }
  .voice-list-p{ padding: .37rem 0 .36rem; height: .37rem; line-height: .37rem; font-size: .3rem; color: #5d5d5d; border-bottom: .01rem solid #f9f9f9; }
  .voice-list-p font{ font-size: .18rem; color: #e38c0f; }
  .voice-list-p.curr{ color: #ff7328; }
  .voice-list-p img{ display: inline-block; margin-right: .19rem; width: .31rem; height: .37rem; }
  .voice-list-p img.fl{ margin-right: .15rem; }

  .alert_login,.alert_card {position: absolute;}



  /*注册弹窗*/
  .login_box{position: absolute;left: .26rem;right: .26rem;bottom: -70%;padding:.83rem .26rem .3rem .26rem;border-radius: .18rem .18rem 0 0;background: #fff;}
  .alert_login .login_close{top: .22rem;}
  .login_tit{font: bold .28rem "Microsoft YaHei";color: #0f0f0f;}
  .login_li{position:relative;width:100%;height:.87rem;margin-top: .23rem;padding-left:.9rem;border-radius: .12rem;background: #fafafa;}
  .login_li_icon{position: absolute;top:50%;left: .27rem;width:auto;height: .4rem;margin-top: -.2rem;}
  .login_li input{display: inline-block;width: 100%;height: 100%;padding:.2rem 0;font: .26rem "Microsoft YaHei";color: #666;background: #fafafa;}
  .login_li .box{position: absolute;left: 0;top: 0;width: 100%;height: 100%;}
  .login_li .flex{border-radius: .12rem;}
  .login_li .flex:first-child{ padding-left: .9rem;background: #fafafa;}
  .yzm_btn{width: 2.45rem;margin-left:.2rem;font: .26rem/.87rem "Microsoft YaHei";color: #fff;background: #f9b544;}
  .yzm_btn.disabled{ background: #cacaca; }
  .login_btn{width: 100%;height: .85rem;margin-top: .9rem;font: bold .3rem/.85rem "Microsoft YaHei";color: #fff;background: #f9b544;}
  .alert_login.curr{display: block;}
  .alert_login.curr .login_box{-webkit-animation: slideUP .3s linear;animation: slideUP .3s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .load-tip{height: auto;}

</style>



// WEBPACK FOOTER //
// src/page/study-detail/study-detail.vue